import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { t } from '@/i18n';
import { toast } from '@/stores/toast';
import { ApiError } from './client';

/** Изтеклата сесия се вижда като екран за вход, не като червен балон. */
function shouldToast(error: unknown): boolean {
  if (error instanceof ApiError) return error.status !== 401;
  return true;
}

function describe(error: unknown): { title: string; body?: string } {
  if (error instanceof ApiError) {
    const fieldMessages = error.fields
      ? Object.values(error.fields)
          .flat()
          .slice(0, 3)
          .join(' · ')
      : '';
    return fieldMessages ? { title: error.message, body: fieldMessages } : { title: error.message };
  }
  if (error instanceof Error && error.message) return { title: t.errors.unknown, body: error.message };
  return { title: t.errors.unknown };
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Единадесет буса и ~2.4 товара на ден: агресивното повторно теглене
      // само трепка на екрана.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Тихите заявки (напр. предположения за адрес) не вдигат балон.
      if (query.meta?.silent === true) return;
      if (!shouldToast(error)) return;
      const { title, body } = describe(error);
      toast.error(title, body);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.meta?.silent === true) return;
      if (!shouldToast(error)) return;
      const { title, body } = describe(error);
      toast.error(title, body);
    },
  }),
});
